import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import Input from '../common/Input';
import DatePickerInput from '../common/DatePickerInput';

const Titles = ({ fields, meta: { touched, error } }) => (
  <div className="dinamic-container">
    <div className="add-titles">
      <h5>Títulos</h5>
      <button
        className="add-button"
        type="button"
        onClick={() => fields.push({})}
      >
        +
      </button>
    </div>
    {touched && error && <span>{error}</span>}
    {fields.map((title, index) =>
      <div className="title-wrapper" key={index}>
        <div className="title-item">
          <Field
            name={`${title}.name`}
            type="text"
            label="Nombre"
            placeholder="Ej: Maestro"
            component={Input}
          />
        </div>
        <div className="title-item">
          <Field
            name={`${title}.date`}
            label="Fecha"
            showYearDropdown
            placeholder="DD/MM/AAAA"
            component={DatePickerInput}
          />
        </div>
        <button
          className="add-button"
          type="button"
          onClick={() => fields.remove(index)}
        >
          <i className="material-icons">
            clear
          </i>
        </button>
      </div>
    )}
  </div>
);

const { object } = PropTypes;

Titles.propTypes = {
  fields: object,
  meta: object
};

export default Titles;



// WEBPACK FOOTER //
// ./src/components/title/Titles.js